import "./App.css";
import React from "react";
import { useQuery } from "react-query";
import { read, utils } from "xlsx";
import FinderTable from "./components/FinderTable";

export default function App(props) {
  const url = props.config.url;
  const { data, status } = useQuery(
    "TrustCenter" + props.id,
    () => fetch(url).then((res) => res.arrayBuffer()),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
    }
  );

  if (status === "loading") {
    return <p>Loading...</p>;
  }
  if (status === "error") {
    return <p>Error...</p>;
  }
  const wb = read(data);
  /* get the first worksheet */
  const ws = wb.Sheets[wb.SheetNames[props.config.sheetNumber]];
  let jsonTable = utils.sheet_to_json(ws, {
    header: 1,
    blankrows: false,
    defval: null,
    raw: true,
  });
  const jsonHeader = jsonTable[0];
  jsonTable = jsonTable.slice(1);

  jsonTable=jsonTable.filter((row,index) => {
    if (row[0]===null) return false;
    row[0].id=index;
    return row;
  });
  console.log(jsonTable);
  let fuzeTable=jsonTable.flat();
  fuzeTable=fuzeTable.filter(n => n).map(item => item.v);
  fuzeTable=fuzeTable.filter((item,index) => fuzeTable.indexOf(item)===index );
  fuzeTable=fuzeTable.map((item,index) => {
    return {id:index,name:item};
  });
  console.log(fuzeTable);
  return (
    <FinderTable config={props.config} jsonTable={jsonTable} jsonHeader={jsonHeader} fuzeTable={fuzeTable} />
  );
}
